<script setup>
import {useDashboardStore} from "../../../stores/DashboardStore";
import {onMounted, ref} from "vue";
import axios from 'axios';
import CardSettings from "./CardSettings.vue";

const store = useDashboardStore();

let tournaments = ref([]);


onMounted(() => {
  axios.get('/dashboard/recommended').then(({data}) => {
    if (data['success']) {
      tournaments.value = data['list'];
    }
  })
})
</script>

<template>
  <div class="bs-shadow-card cardStyle">
    <card-settings name="recommended"/>
    <div class="flex justify-between">
      <div class="w-full">
        <div class="bs-card-header">Recommended Tournaments</div>
        <div v-for="tournament of tournaments" class="tournamentRow sm:flex-row">
          <a :href="`/tournaments/${tournament.slug}`" class="label">{{ tournament.name }}</a>
          <div class="text">{{ tournament.spots }} spots left</div>
          <div class="text">{{ store.formattedDate(tournament) }}</div>
          <div class="text flex2">{{ store.formattedAddress(tournament) }}</div>
        </div>
      </div>
      <div class="hidden">
        <div class="map">map here</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cardStyle {
  @apply w-full relative mb-4;
  padding-top: 32px;
  padding-bottom: 38px;
}

.tournamentRow {
  @apply mb-4 flex flex-col;
}

.label {
  @apply font-bold text-black pr-1;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: .02rem;
  flex: 2;
}

.text {
  @apply font-medium text-stone-400 pr-1;
  flex: 1;
  font-size: 16px;
  line-height: 19px;
}

.flex2 {
  flex: 2 !important;
}

</style>